/**
 * 拼接 GM 训练测谎 Prompt
 */
export function formatQuestionBankLines(items) {
  if (!items?.length) return ''
  return items
    .map((item, index) => {
      const question = item.question_ko || item.questionKo || ''
      const answer = item.answer || ''
      return `${index + 1}. ${question} → ${answer}`
    })
    .join('\n')
}

export function buildGmTrainLiePrompt(template, context = {}) {
  if (!template) return ''
  const {
    roleName = '',
    vocationName = '',
    level = '',
    aiAnswerCustom = '',
    question = '',
    questionBankLines = ''
  } = context

  let prompt = String(template)
  prompt = prompt.replace(/\$\{role_name\}/g, roleName)
  prompt = prompt.replace(/\$\{vocation_name\}/g, vocationName)
  prompt = prompt.replace(/\$\{level\}/g, level !== '' && level != null ? String(level) : '')
  prompt = prompt.replace(/\$\{角色相关问题\}/g, aiAnswerCustom)
  prompt = prompt.replace(/\$\{问题\}/g, question)
  prompt = prompt.replace(/\{题库按顺序拼接\}/g, questionBankLines)

  if (roleName) {
    prompt = prompt.replace(/角色名（role_name）：[^\n]*/g, `角色名（role_name）：${roleName}`)
  }
  if (vocationName) {
    prompt = prompt.replace(/职业（vocation_name）：[^\n]*/g, `职业（vocation_name）：${vocationName}`)
  }
  if (level !== '' && level != null) {
    prompt = prompt.replace(/等级（level）：[^\n]*/g, `等级（level）：${level}`)
  }

  return prompt
}

export function getRoleAnswerTestContext(role) {
  if (!role) {
    return {
      roleName: '',
      vocationName: '',
      level: '',
      aiAnswerCustom: ''
    }
  }
  const datas = role.datas || {}
  return {
    roleName: role.name || datas.role_name || '',
    vocationName: datas.vocation_name || '',
    level: role.level != null ? String(role.level) : '',
    aiAnswerCustom: datas.ai_answer_custom || ''
  }
}
